/**
 * documentRelevanceTier — AP4. Map an AI-classified document
 * relevance score (0..1) to a reviewer-facing tier:
 *
 *   - `'primary'`    — drove a conclusion (≥ 0.85, success-green)
 *   - `'supporting'` — corroborates a section (0.50–0.85, primary-cyan)
 *   - `'reference'`  — background only (< 0.50, muted-gray)
 *
 * Each tier has a stable id + label + tone-class string that the
 * appendix render reads directly. Numeric score moves to a hover
 * tooltip so the row reads as a category, not a debug number.
 */
export type DocumentRelevanceTier = 'primary' | 'supporting' | 'reference';

export interface RelevanceTierDescriptor {
  tier: DocumentRelevanceTier;
  label: string;
  /** Tailwind text tone (success / primary / muted). */
  toneClass: string;
}

export function documentRelevanceTier(score: number | null | undefined): RelevanceTierDescriptor {
  const s = typeof score === 'number' && Number.isFinite(score) ? score : 0;
  if (s >= 0.85) {
    return { tier: 'primary', label: 'Primary', toneClass: 'text-success' };
  }
  if (s >= 0.5) {
    return { tier: 'supporting', label: 'Supporting', toneClass: 'text-primary' };
  }
  return { tier: 'reference', label: 'Reference', toneClass: 'text-text-muted' };
}
